import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ChangeModelWarning = ({ anchorRef, generic, confirm, close, classes }) =>
  <div
    className={classes.container}
    style={{
      top: anchorRef.offsetTop + anchorRef.offsetHeight + (generic ? 0 : anchorRef.offsetParent.offsetTop),
      left: Math.round(anchorRef.offsetLeft + anchorRef.offsetWidth / 2 + (generic ? 0 : anchorRef.offsetParent.offsetLeft))
    }}
  >
    <div
      className={classes.content}
      style={{ transform: `translate(${generic ? '-75%' : '-50%'}, 12px)` }}
    >
      <span className={classes.header}>
        <FontAwesomeIcon icon='exclamation-triangle' className={classes.warning} />
        Data Will Be Deleted
      </span>
      <span style={{ padding: '.5rem' }}>
        { generic
          ? "This door controller exceeds the limits of the generic model.  Data will be deleted to match the generic model's limits"
          : "This door controller exceeds the limits of the selected model.  Data will be deleted to match the new model's limits"
        }
      </span>
      <div className={classes.buttonWrapper}>
        <button
          className={classes.confirmButton}
          onClick={confirm}
        >
          Select Controller Anyway
        </button>
        <button
          className={classes.cancelButton}
          onClick={close}
        >
          Cancel
        </button>
      </div>
    </div>
    <div className={classes.arrow} style={{ transform: `translate(${generic ? '-75%' : '-50%'}, 4px)` }} />
  </div>

export default injectSheet(style)(ChangeModelWarning)



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ChangeModelWarning/index.js